import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 679980 666640"
    {...props}
  >
    <path
      d="M669760 197704 488236 10640C482696 2560 477156 0 469056 0c-7670 0-15769 2560-21309 7870l-5120 5330c-10650 10869-13640 29409 0 42818l53268 56059-63918 64118-72448-74788c-10659-10650-29399-10650-42608 0l-5540 8100c-13200 10639-13200 29409 0 40049l8100 10659L81708 389899c-5540 5309-8100 15979-8100 24069l23859 104187-85647 82657c-15760 13410-15760 37509 0 53479 13639 15969 40478 15969 56248 2770l85647-85448 98858 26639c8099 2560 18749 0 26849-5309l235213-232454 10660 10640c11079 10870 29409 10870 43048 0l5120-5330c5540-5310 8100-13409 8100-21299 0-8100-2560-15970-8100-21330l-69468-72217 64348-64128 56249 56228c5119 5330 13199 7890 21309 7890 8120 0 13220-2560 21319-7890l2560-5540c13600-10630 13600-29159-20-39809zM418338 381989l-42609-45589c-5540-5330-13200-5330-18739 0-5540 5330-5540 13410 0 18740l42608 45378-18759 18740-42609-45359c-5120-5350-13220-5350-18739 0-5540 5310-5540 13210 0 18739l43038 45379-18739 15970-43049-42839c-5120-5310-13219-5310-18739-2540-5120 5310-5120 13420 0 18729l43028 45389-18739 18540-43049-45379c-5100-5330-13209-5330-18329 0-5540 5330-5540 13409 0 18739l42609 45379-34949 34739-98858-26639-2559-2770-21320-98857 224574-216254 122716 125506-58788 56259z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
